import React from 'react'
import {useTranslation} from 'react-i18next'

export default function TableHead() {
  const {t} = useTranslation()

  const headTable = [
    {
      name: t('srNo'),
      width: '120px',
    },
    {
      name: t('product'),
      width: '150px',
    },
    {
      name: t('sku'),
      width: '150px',
    },
    {
      name: t('quantity'),
      width: '150px',
    },
    {
      name: t('price'),
      width: '150px',
    },
    {
      name: t('rating'),
      class: 'min-w-150px ',
    },
    {
      name: t('status'),
      class: 'min-w-150px ',
    },

    {
      name: t('action'),
      class: 'max-w-120px',
    },
  ]

  return (
    <thead>
      <tr
        // style={{display:'flex',justifyContent:'space-between'}}
        className='fw-bold text-muted'
      >
        {headTable.map((e, i) => (
          <th
            style={{
              textAlign: i === 0 ? 'start' : 'start',
              minWidth: i === headTable.length - 1 ? '120px' : e.width,
            }}
            key={i}
            className={e.class}
          >
            {e.name}
          </th>
        ))}
      </tr>
    </thead>
  )
}
